var _typeof = require("@babel/runtime/helpers/typeof");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.array.concat.js");
/* globals ga, lh, abodo */
var GoogleAnalytics = {
  isAvailable: function isAvailable() {
    return typeof ga === "function";
  },
  trackImpression: function trackImpression(eventAction, eventLabel, eventValue) {
    eventValue = parseInt(eventValue);
    if (isNaN(eventValue)) {
      eventValue = 0;
    }
    GoogleAnalytics.trackEvent("impression", eventAction, eventLabel, eventValue, {
      nonInteraction: 1
    });
  },
  trackCall: function trackCall(actionClass, labelText) {
    GoogleAnalytics.trackEvent("Call landlord", actionClass, labelText);
    if ($("#list_hub_key").length > 0) {
      lh("submit", "OFFICE_PHONE_CLICKED", {
        lkey: $("#list_hub_key").val()
      });
    }
    document.cookie = "sent_lead=true";
  },
  trackFavorite: function trackFavorite(favoriteAction, favoriteLocation) {
    if (typeof abodo !== "undefined" && typeof abodo.helpers !== "undefined") {
      abodo.helpers.HotjarHelper.tagRecording(["Favorite"]);
    }
    GoogleAnalytics.trackEvent("Favorite", favoriteAction, favoriteLocation);
  },
  trackFilter: function trackFilter(filterAction, filterLocation) {
    GoogleAnalytics.trackEvent("Filter", filterAction, filterLocation);
  },
  trackScroll: function trackScroll(scrollPage, scrollLocation) {
    GoogleAnalytics.trackEvent("Scroll", scrollPage, scrollLocation);
  },
  trackShare: function trackShare(shareAction, shareLocation) {
    GoogleAnalytics.trackEvent("Share", shareAction, shareLocation);
  },
  trackClick: function trackClick(actionClass, labelText, eventValue) {
    GoogleAnalytics.trackEvent("Click", actionClass, labelText, eventValue);
  },
  trackEvent: function trackEvent(category, action, label, value, eventOptions) {
    if (!GoogleAnalytics.isAvailable()) {
      GoogleAnalytics.logToConsole("No ga but would have sent category: ".concat(category, ", action: ").concat(action, ", label: ").concat(label, ", value: ").concat(value));
      return false;
    }
    if (typeof eventOptions === "undefined") {
      eventOptions = {};
    }
    ga("send", "event", category, action, label, value, eventOptions);
  },
  trackPageView: function trackPageView(urlOfPage) {
    if (!GoogleAnalytics.isAvailable()) {
      GoogleAnalytics.logToConsole("No ga but would have sent a PageView with url: ".concat(urlOfPage));
      return false;
    }
    ga("send", "pageview", urlOfPage);
    return true;
  },
  logToConsole: function logToConsole(logStr) {
    if (_typeof(window.console) !== "object") {
      return false;
    }
    window.console.log(logStr);
  }
};
module.exports = GoogleAnalytics;